export const heroStats = [
  { id: "stat-1", value: "2004–2012", label: "漫画连载区间" },
  { id: "stat-2", value: "42 卷", label: "单行本全卷数" },
  { id: "stat-3", value: "203 集", label: "电视动画集数" },
  { id: "stat-4", value: "7 种", label: "死气之火属性" },
];

export const navLinks = [
  { id: "nav-overview", href: "#overview", label: "作品速览" },
  { id: "nav-characters", href: "#characters", label: "角色图鉴" },
  { id: "nav-arcs", href: "#arcs", label: "篇章解析" },
  { id: "nav-flame", href: "#flame", label: "火焰体系" },
  { id: "nav-growth", href: "#growth", label: "成长轨迹" },
  { id: "nav-ending", href: "#ending", label: "结局讨论" },
  { id: "nav-guide", href: "#guide", label: "观前指南" },
  { id: "nav-faq", href: "#faq", label: "常见问题" },
];

export const overviewFacts = [
  { id: "fact-1", term: "作品原名", detail: "家庭教師ヒットマンREBORN!" },
  { id: "fact-2", term: "作者", detail: "天野明（Akira Amano）" },
  { id: "fact-3", term: "连载杂志", detail: "《周刊少年 Jump》，2004 年至 2012 年" },
  { id: "fact-4", term: "动画版", detail: "2006 年至 2010 年播出，共 203 集" },
  { id: "fact-5", term: "作品类型", detail: "搞笑日常 + 少年热血 + 战斗成长" },
  { id: "fact-6", term: "故事舞台", detail: "以并盛町为中心，逐步扩展到黑手党世界" },
];

export const overviewParagraphs = [
  "《我的家庭教师》从一开场就把反差感拉到最满：一个成绩垫底、体育垫底、被同学叫作废柴纲的中学生沢田纲吉，某天家里突然多了一位自称家庭教师的小婴儿——里包恩。里包恩不只是来辅导功课的，他的真实身份是顶尖杀手，任务是把纲吉培养成意大利黑手党彭格列家族的第十代首领。",
  "于是故事在两条线索之间来回切换：一边是并盛町里荒唐又温暖的校园日常，一边是接踵而至的家族纷争与生死战斗。前者负责让人笑出声，后者负责让角色真正改变。理解这部作品的关键，就在于看懂这两条线是如何互相支撑的。",
  "本站把这部作品拆成几个可以独立浏览的部分：先速览背景，再逐一认识主要角色，然后按篇章理清剧情脉络，接着补上战斗体系与人物成长这两块容易看漏的内容，最后把结局相关的讨论集中呈现。你可以顺着读，也可以直接跳到最关心的一块。",
];

export const readingPromises = [
  {
    id: "promise-1",
    icon: "ri-user-star-line",
    title: "角色图鉴",
    desc: "按阵营筛选阅览，每位角色给出身份、火焰属性与性格要点，避免脸熟却叫不出名字。",
  },
  {
    id: "promise-2",
    icon: "ri-book-open-line",
    title: "篇章脉络",
    desc: "从日常篇到代理人战争，逐个梳理每段剧情的核心冲突、登场势力与不可错过的看点。",
  },
  {
    id: "promise-3",
    icon: "ri-discuss-line",
    title: "结局讨论",
    desc: "把围绕结局的几种主流看法并排列出，标明哪些是作品给出的，哪些只是观众的解读。",
  },
];